export default () => {
  const link = document.querySelector('.js-open-filler-mat')
  if ( ! link ) return

  link.addEventListener('click', e => {
    e.preventDefault()
    let r = window.confirm(`Weet je zeker dat je naar een andere pagina wilt navigeren? Je ingevulde gegevens gaan dan verloren.`)
    if (r == true) {
      window.location = e.currentTarget.href
    }
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/FillerMat.js